export const CLONE_JOURNEY_BUTTON_TEST_ID = 'clone-journey-button';
export const CLONE_JOURNEY_INPUT_TEST_ID = 'clone-journey-input';
export const CLONE_JOURNEY_PROJECT_SELECT = 'clone-journey-project-select';
export const DIFF_PROJECT_INFO_BANNER = 'different-project-info-banner';
export const CAMPAIGN_TOGGLE = 'campaign-toggle';

export const ERROR_MESSAGE = 'Could not copy journey';
export const LOCALES_BETA_CLONING_JOURNEY_ERROR_MESSAGE =
  'error.templates.invalidLocalesFlagToCloneTemplate';

export const CLONE_TO_DIFFERENT_PROJECT_MESSAGE =
  'This Journey and all of its Tiles will be copied to another project. Some of the resulting Tiles may need to be updated to work within that project.';
